<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:ItemErrorMessage
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2024/03/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div
		v-if="errFlg && errMsg != ''"
		class="contents__caution--div div_row error-message-area item-error-margin"
		:class="[classDiv != '' ? classDiv : '']"
	>
		<div class="contents__caution--div_mark item-error-icon-margin">
			<p class="contents__caution--error contents__caution--multiple">
				<font-awesome-icon
					icon="exclamation-triangle"
					class="error-itemsmsg-icon-size"
				/>
			</p>
		</div>
		<div class="error-msg-list">
			<ul v-html="errMsg" />
		</div>
	</div>
</template>

<script>
import { STORE_ERROR_IS_ERRFLG, STORE_ERROR_GET_INPUT_ERRMSG } from '@/const/store.js';

export default {
	props: {
		groupId: {type: String, default: ''},					// 項目グループID
		classDiv: {type: String, default: ''},					// コントロールエリアのスタイル
	},
	computed: {
		errFlg: function () {
			return this.$store.getters[STORE_ERROR_IS_ERRFLG];
		},
		errMsg: function() {
			let imputErrMsg = this.$store.getters[STORE_ERROR_GET_INPUT_ERRMSG];
			let resultMsg = '';

			// 入力チェックエラーメッセージ編集
			if ( imputErrMsg != null && imputErrMsg.length != 0 ) {
				for ( let i = 0; i < imputErrMsg.length; i++ ) {
					
					if (imputErrMsg[i].key === this.groupId) {
						resultMsg = resultMsg + '<li>' + imputErrMsg[i].value.replace(new RegExp(/\r\n|\n/, 'g'), '<br>') + '</li>';
					}
				}
			}
			return resultMsg;
		},
		replaceMessage: function( msg ) {
			return '<li>' + msg.replace(new RegExp(/\r\n|\n/, 'g'), '<br>') + '</li>'
		}
	},
}
</script>

<style scoped>
</style>